import { render, staticRenderFns } from "./TenantUserShow.vue?vue&type=template&id=4a809a2c"
import script from "./TenantUserShow.vue?vue&type=script&lang=ts"
export * from "./TenantUserShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports